import { render, staticRenderFns } from "./LatestFinding.vue?vue&type=template&id=0443ae92&"
import script from "./LatestFinding.vue?vue&type=script&lang=js&"
export * from "./LatestFinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports